module.exports = __webpack_public_path__ + "static/media/BodyScan10.fa670ed4.mp3";